$(document).ready(function () {
	animationLoader();
	setBackgroundElement();
	// header
	header.init();
	mappingMenu();
	// swiper
	swiperInit();
	listFaq();
	boxMenuNavi();
	appendToPolicy();
	clickCart();
});
function clickCart() {
	if ($(window).width() >= 1024) {
		$(".wrap-cart").click(function () {
			$(this)
				.closest("header")
				.find(".shopping-cart-wrapper")
				.toggleClass("active");
		});
	}
	$(window).click(function () {
		$(".shopping-cart-wrapper").removeClass("active");
	});

	$(".shopping-cart-wrapper").click(function (event) {
		event.stopPropagation();
	});
	$(".wrap-cart").click(function (event) {
		event.stopPropagation();
	});
	$(".click-more-address").click(function () {
		$(".user-info").slideToggle();
	});
	if ($(window).width() < 1024) {
		let linkCart = $(".shopping-cart-wrapper .btn-buy-product").attr(
			"href"
		);
		$(".wrap-cart .cart").attr("href", linkCart);
	}
	$(window).scroll(function (event) {
		let activeTrue = true;
		if (
			$(".shopping-cart-wrapper").hasClass("active") &&
			activeTrue == true
		) {
			activeTrue = false;
			$(".shopping-cart-wrapper").removeClass("active");
			setTimeout(() => {
				activeTrue = true;
			}, 3000);
		}
	});
}
/*==================== Append To Policy ====================*/
function appendToPolicy() {
	$(".policy").appendTo(".selected-policy");
}
/*==================== Box Menu Navigation ====================*/
function boxMenuNavi() {
	$(".box-navigation .dropdown>a").click(function () {
		$(this).parent().find(".list-menu-dropdown").slideToggle();
		$(this).parent().toggleClass("active");
		return false;
	});
}
/*==================== Faq ====================*/
function listFaq() {
	$(".list-faq .title").click(function () {
		$(this).toggleClass("active");
		$(this).next().slideToggle();
	});
	$(".box-navigation .title").click(function () {
		$(this).parent().toggleClass("active");
	});
}
/*==================== setBg ====================*/
function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-size": "cover",
			"background-position": "center center",
			"background-image": "url(" + background + ")",
		});
	});
}
/*==================== Mapping Menu ====================*/
function mappingMenu() {
	let ww = $(window).width();
	if (ww < 1024) {
		$(".header-main-menu .list-menu-main").appendTo(".menu-mobile-main");
	}
	$(".section-product-about").appendTo(".page-about-main.section-6");
	$(".select-sort").appendTo(".wrap-tab-list-select");
	$(".get-img-search").appendTo(".search-form-main .img");
	$(".searchbox .wrap-form-subscribe").appendTo(".banner-text-form");
}
/*==================== Animation loader  ====================*/
function animationLoader(e) {
	$("body").addClass("loaded");
}
/*==================== Append Click Scroll Tab ====================*/
function clickScrollTab() {
	$(".wrap-tab-link ul").scrollTo("li.active", 800);
	let numberTab = $(".tabslet-tab li").length;
	let countNumber = 1;
	if (numberTab > 2) {
		$(".tabslet-tab").wrap('<div class="number-tab-wrap"></div>');
		$(".number-tab-wrap").append(
			'<div class="icon-next"><div class="next"><em class="material-icons">navigate_next</em></div></div>'
		);
		$(".icon-next").click(function () {
			if (countNumber < numberTab - 1) {
				$(this)
					.parent()
					.find(".tabslet-tab")
					.scrollTo("li:eq(" + countNumber + ")", 800);
				countNumber++;
			} else {
				countNumber = 1;
				$(this).parent().find(".tabslet-tab").scrollTo("li:eq(0)", 800);
			}
		});
	}
}
/*==================== JS Other ====================*/
function height(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height);
		}, 100);
	});
}
let header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	clickHambuger: function () {
		$(".hambuger").click(function () {
			$(this).toggleClass("active");
			$(".overlay").toggleClass("active");
			$(".menu-mobile-main").toggleClass("isOpen");
		});
	},
	menuMobile: function () {
		if ($(window).width() < 1024) {
			$("header .header-bottom-menu ul")
				.appendTo(".menu-mobile-main")
				.wrap('<div class="list-main-menu product-list"></div>');
			$("header .header-top-menu .list-main-menu").appendTo(
				".menu-mobile-main"
			);
			const childActive = $(".list-main-menu.product-list").find(
				".active"
			).length;
			if (childActive > 0) {
				$(".list-main-menu.product-list").slideDown();
				$('.menu-product-main').addClass('active')
			}
		}
		$(".menu-mobile-main .menu-product-main").click(function () {
			$(".product-list").slideToggle();
			$(this).toggleClass("active");
		});
		$(".overlay").click(function () {
			$(".product-list").removeClass("active");
			$(this).removeClass("active");
			$(".overlay").removeClass("active");
			$(".hambuger").removeClass("active");
			$(".menu-mobile-main").removeClass("isOpen");
		});
	},
	init: function () {
		header.clickHambuger();
		header.menuMobile();
	},
};
/*==================== Swiper ====================*/
function swiperInit() {
	var bannerHome = new Swiper(".banner-home .swiper", {
		grabCursor: true,
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: true,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		autoplay: {
			delay: 5000,
		},
		speed: 700,
		navigation: {
			nextEl: ".banner-home .btn-next",
			prevEl: ".banner-home .btn-prev",
		},
	});
	var pageVideoBanner = new Swiper(".page-video-banner .swiper", {
		slidesPerView: 2,
		spaceBetween: 30,
		autoplay: {
			delay: 5000,
		},
		speed: 700,
		navigation: {
			nextEl: ".page-video-banner .btn-next",
			prevEl: ".page-video-banner .btn-prev",
		},
		pagination: {
			el: ".page-video-banner .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			575: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			768: {
				spaceBetween: 15,
				slidesPerView: 4,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 4,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 5,
			},
		},
	});
	var homeHotProduct = new Swiper(".home-hot-product .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
		},
		speed: 700,
		navigation: {
			nextEl: ".home-hot-product .btn-next",
			prevEl: ".home-hot-product .btn-prev",
		},
		pagination: {
			el: ".home-hot-product .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 4,
			},
			1280: {
				slidesPerView: 5,
				spaceBetween: 10,
			},
		},
	});
	var homeAllProduct = new Swiper(".home-all-product .swiper", {
		spaceBetween: 15,
		slidesPerView: 2,
		speed: 700,
		navigation: {
			nextEl: ".home-all-product .btn-next",
			prevEl: ".home-all-product .btn-prev",
		},
		pagination: {
			el: ".home-all-product .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 2,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
	var couponSwiper = new Swiper(".coupon-swiper .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
		},
		speed: 700,
		navigation: {
			nextEl: ".coupon-swiper .btn-next",
			prevEl: ".coupon-swiper .btn-prev",
		},
		pagination: {
			el: ".home-news .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 2,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1230: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
	var homeNews = new Swiper(".home-news .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
		},
		speed: 700,
		navigation: {
			nextEl: ".home-news .btn-next",
			prevEl: ".home-news .btn-prev",
		},
		pagination: {
			el: ".home-news .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 2,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1230: {
				slidesPerView: 3,
				spaceBetween: 45,
			},
		},
	});
	var productThumb = new Swiper(
		".page-product-detail .product-img-thumb .swiper",
		{
			slidesPerView: 3,
			spaceBetween: 10,
			navigation: {
				nextEl: ".page-product-detail .product-img-thumb .btn-next",
				prevEl: ".page-product-detail .product-img-thumb .btn-prev",
			},
			pagination: {
				el: ".page-product-detail .product-img-thumb .swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				575: {
					spaceBetween: 10,
					slidesPerView: 4,
				},
				1024: {
					spaceBetween: 10,
					slidesPerView: 4,
				},
				1280: {
					spaceBetween: 10,
					slidesPerView: 5,
				},
			},
		}
	);
	var productMain = new Swiper(
		".page-product-detail .product-img-main .swiper",
		{
			spaceBetween: 10,
			speed: 800,
			slidesPerView: 1,

			thumbs: {
				swiper: productThumb,
			},
		}
	);
	var productDetail = new Swiper(".box-product-other .swiper", {
		spaceBetween: 15,
		slidesPerView: 2,
		observer: true,
		observeParents: true,
		speed: 700,
		navigation: {
			nextEl: ".box-product-other .btn-next",
			prevEl: ".box-product-other .btn-prev",
		},
		pagination: {
			el: ".box-product-other .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 2,
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
	//Max Height for year
	if ($(window).width() >= 1024) {
		let heightImg = $(
			".page-gioi-thieu.section-2 .content-img .wrap-img"
		).height();
		$(".page-gioi-thieu.section-2 .wrap-year .slide-year").css(
			"max-height",
			heightImg - 100
		);
	}
	var box_year = new Swiper(".wrap-box-year .wrap-year .swiper", {
		spaceBetween: 0,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				spaceBetween: 0,
				slidesPerView: 4,
			},
			1024: {
				direction: "vertical",
				slidesPerView: 6,
				spaceBetween: 0,
			},
			1280: {
				direction: "vertical",
				slidesPerView: 8,
				spaceBetween: 0,
			},
		},
	});
	var box_year_main = new Swiper(".wrap-box-year .content-img .swiper", {
		spaceBetween: 0,
		grabCursor: true,
		effect: "creative",
		navigation: {
			nextEl: ".wrap-box-year .btn-next",
			prevEl: ".wrap-box-year .btn-prev",
		},
		creativeEffect: {
			prev: {
				shadow: true,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		thumbs: {
			swiper: box_year,
		},
	});
	if ($(".page-product-list").length) {
		$(".item-product-list").each(function (index) {
			$(this).addClass("index-slide-" + index);
			let nameSlide = ".index-slide-" + index;
			new Swiper(`${nameSlide} .swiper`, {
				spaceBetween: 15,
				slidesPerView: 2,
				observer: true,
				observeParents: true,
				speed: 700,
				navigation: {
					nextEl: `${nameSlide} .btn-next`,
					prevEl: `${nameSlide} .btn-prev`,
				},
				pagination: {
					el: `${nameSlide} .swiper-pagination`,
					clickable: true,
				},
				breakpoints: {
					768: {
						spaceBetween: 15,
						slidesPerView: 2,
					},
					1024: {
						spaceBetween: 15,
						slidesPerView: 3,
					},
					1280: {
						slidesPerView: 4,
						spaceBetween: 30,
					},
				},
			});
		});
	}
}
$(document).on("scroll", function () {
	header.scrollActive();
});
function alertConsole() {
	alert('ung')
}
